import { useEventInterpolationsFetcher } from './event'
import { useFormNonComplianceInterpolationsFetcher } from './formNonCompliance'
import { useNonComplianceGroupInterpolationsFetcher } from './nonComplianceGroup'
import { useServiceOrderInterpolationsFetcher } from './serviceOrder'
import { useServiceOrderNonComplianceInterpolationsFetcher } from './serviceOrderNonCompliance'

// service_order_tag_assigned/removed despacham o mesmo registro achatado que a entidade `service_order`
// (raiz "service_order" na interpolação do backend, sem aninhamento como em `event`), então usam o
// mesmo fetcher de "Campos dinâmicos" — nunca tinham sido incluídos aqui, deixando o dropdown vazio.
const SERVICE_ORDER_SHAPED_ENTITIES = ['service_order', 'service_order_tag_assigned', 'service_order_tag_removed']

// service_order_reply (evento "resposta editada") despacha um `Models.Reply` com a ServiceOrder
// aninhada em `.service_order` (confirmado em `Preloaders.ServiceOrderReplies`, que reaproveita
// `Preloaders.ServiceOrders.load/2` com os mesmos preloads/joins usados por `Preloaders.Events`) —
// ou seja, o mesmo shape aninhado de `event`, não o shape achatado de `service_order`. Por isso usa
// o mesmo fetcher de "Campos dinâmicos" (que já inclui `fieldsOptions`/`placeFieldsOptions`, os
// "campos adicionais"). Antes deste fix, `service_order_reply` não caía em nenhum dos dois fetchers
// e o dropdown de campos dinâmicos ficava vazio para essa entidade.
const EVENT_SHAPED_ENTITIES = ['event', 'service_order_reply']

export const useInterpolations = (origin, checklistId, placeType, opts = { interpolation_as_image: false }) => {
  return [
    ...useServiceOrderInterpolationsFetcher(
      !SERVICE_ORDER_SHAPED_ENTITIES.includes(origin),
      checklistId,
      placeType,
      opts
    ),
    ...useServiceOrderNonComplianceInterpolationsFetcher(origin !== 'non_compliance_event'),
    ...useNonComplianceGroupInterpolationsFetcher(origin !== 'non_compliance'),
    ...useFormNonComplianceInterpolationsFetcher(origin !== 'forms_non_compliance_event'),
    ...useEventInterpolationsFetcher(!EVENT_SHAPED_ENTITIES.includes(origin), checklistId, placeType, opts, origin)
  ]
}
